import React from "react";
import Hero from "./Hero";
import CoreFunctionalities from "./CoreFunctionalities";
import NewsLetter from "./Newsletter";
import Approach from "./Approach";
import CourseMarketPlace  from "./HowItWorks";
import FrequentlyAskedQuestions from "./Faqs";
import Testimonials from "./Testimonials";
import Partners from "./Partners";

const LandingPage: React.FC = () => {
  return (
    <main className="flex flex-1 justify-center items-start py-5 size-full max-md:max-w-full">
      <div className="flex overflow-hidden flex-col flex-1 shrink w-full basis-0 max-w-full min-w-[240px] max-md:max-w-full">
        <div className="flex flex-col w-full max-md:max-w-full">
          <Hero />
          <CoreFunctionalities />
          <Approach />
          <CourseMarketPlace />
          <Testimonials />
          <Partners/>
          <FrequentlyAskedQuestions/>
          <NewsLetter />
        </div>
      </div>
    </main>
  );
};

export default LandingPage;
